export function animationDuration(length) {
  return railsEnv === 'test' ? 1 : length;
}

export function pauseForSpecs(functionToPause) {
  if (!window.pausePauseableJavascripts) return functionToPause();

  document.addEventListener('ResumePausedJavascripts', () => {
    functionToPause();
  });
}
